import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/lecture/ballot_animate.gif';

const _withScopeId = n => (_pushScopeId("data-v-6ec1542e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "animate-box"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "animate-content"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "animate-img"
})], -1));

const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}